import { observer } from 'mobx-react';
import Loading from 'components/UI/Loading/Loading';
import { useStores } from 'stores/hooks/hooks';
import { TabViewTabChangeEvent } from 'primereact/tabview';
import { useTranslation } from 'react-i18next';
import React, { FC, useCallback, useState } from 'react';
import styled from 'styled-components';
import { TabPanel, TabView } from 'components/UI/TabView';
import FeaturesSensorsTable from './FeaturesSensorsTable';
import FeatureDetails from './FeatureDetails';

const Container = styled.div`
  width: 100%;
  height: 100%;

  .p-tabview-panels {
    height: 100%;
  }

  .p-tabview-nav {
    margin: 0.5rem 1rem;
  }
`;

const StyledTabView = styled(TabView)`
  height: 100%;
  .p-tabview-nav {
    margin: 0.5rem 1rem;
  }
`;

enum TabKey {
  Details = 0,
  Sensors = 1,
}

const FeaturesSensors: FC = observer(() => {
  const { t } = useTranslation('grower');
  const [tabIndex, setTabIndex] = useState(TabKey.Sensors);
  const {
    resellersStore: { growerSystemSensors }, // TBD: Change
  } = useStores();

  const onTabChange = useCallback(({ index }: TabViewTabChangeEvent) => {
    setTabIndex(index);
  }, []);

  return (
    <Container>
      <StyledTabView
        activeIndex={tabIndex}
        renderActiveOnly
        onTabChange={onTabChange}
      >
        <TabPanel header={t('details')}>
          <FeatureDetails />
        </TabPanel>
        <TabPanel header={t('sensors')}>
          {growerSystemSensors.loading ? <Loading /> : <FeaturesSensorsTable />}
        </TabPanel>
      </StyledTabView>
    </Container>
  );
});

export default FeaturesSensors;
